"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withCsrf = exports.readCsrfToken = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var CSRF_FIELD_NAME = 'yip_csrf_token';

var readCsrfToken = function readCsrfToken() {
  var _el$value;

  if (typeof document === 'undefined') return '';
  var el = document.querySelector('input#csrftoken');
  return (_el$value = el === null || el === void 0 ? void 0 : el.value) !== null && _el$value !== void 0 ? _el$value : '';
};

exports.readCsrfToken = readCsrfToken;

var withCsrf = function withCsrf() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var result = {};
  Object.entries(params).forEach(function (_ref) {
    var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
        k = _ref2[0],
        v = _ref2[1];

    result[k] = String(v);
  });
  var token = readCsrfToken();
  if (token) result[CSRF_FIELD_NAME] = token;
  return result;
};

exports.withCsrf = withCsrf;